<template>
  <appbar-view></appbar-view>

    <v-app>
  <div class="min-h-screen bg-grey-50">
    <v-main>
      <v-container>
        <div class="hidden sm:flex items-center space-x-3 mb-6 px-2">
          <!-- Logo -->
          <img
            src="https://mvexpress.mx/images/logosapp/logomv6.png"
            alt="Logo MV"
            class="w-19 sm:w-16 h-auto object-contain select-none"
          />

          <!-- Icono camión -->

          <!-- Título -->
          <h1 class="text-2xl font-bold text-gray-900 select-none">
            Historial de Pedidos
          </h1>
        </div>

        <!-- Tabla para pantallas grandes -->
        <!-- Tabla para pantallas grandes -->
        <div class="hidden sm:block">
          <v-data-table
            :headers="headers"
            :items="pedidos"
            :search="search"
            item-value="pedido_id"
            dense
            fixed-header
            height="auto"
            class="elevation-2 w-full"
            :items-per-page="20"
            v-model:page="page"
            :sort-by="[{ key: 'pedido_id', order: 'desc' }]"
          >
            <template v-slot:item="{ item, index }">
              <tr :class="index % 2 === 0 ? 'bg-gray-50' : 'bg-white'">
                <td class="px-4 py-2 text-sm font-medium text-gray-700">
                  {{ item.referencia_frog }}
                </td>

                <td class="px-4 py-2 text-sm text-gray-600">
                  {{ item.fecha_pedido.substring(0, 10) }}
                </td>
                <td class="px-4 py-2 text-sm text-gray-600">
                  {{ item.estado === 20 ? "Pagado" : item.estado || "Pagado" }}
                </td>
                <td class="px-4 py-2 text-sm text-gray-600">
                  ${{
                    Number(item.total).toLocaleString("es-MX", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })
                  }}
                </td>

                <td class="px-4 py-2 text-center">
                  <v-btn
                    variant="solo"
                    color="black"
                    small
                    class="text-gray-700 hover:bg-gray-200"
                    @click="showProducto(item)"
                  >
                    <v-icon left size="18" class="text-blue-darken-4">mdi-eye</v-icon>
                    Ver Detalles
                  </v-btn>
                </td>
                <td class="px-4 py-2 text-sm text-gray-600">
                  {{ item.udn || "N/A" }}
                </td>
              </tr>
            </template>

            <template v-slot:footer>
              <div class="flex justify-end px-4 py-2 bg-gray-100">
                <v-pagination
                  v-model:page="page"
                  :length="Math.ceil(pedidos.length / 20)"
                  circle
                  total-visible="7"
                  color="blue-darken-4"
                />
              </div>
            </template>
          </v-data-table>
        </div>

        <!-- Lista para móviles -->
        <div class="sm:hidden flex items-center space-x-2 mt-6 mb-4 px-4">
          <v-icon class="text-blue-600" size="24">mdi-format-list-bulleted</v-icon>
          <h2 class="text-lg font-semibold text-gray-900 select-none">
            Resumen de tus pedidos
          </h2>
        </div>

        <div class="sm:hidden space-y-4 mt-4 px-4">
          <div
            v-for="item in pedidos"
            :key="item.pedido_id"
            class="bg-white shadow-lg rounded-lg p-4 border border-gray-200"
          >
            <div class="text-sm text-gray-700 mb-4 space-y-1 font-sans">
              <p><span class="font-semibold">ID:</span> {{ item.pedido_id }}</p>

              <p>
                <span class="font-semibold">Fecha:</span>
                {{ item.fecha_pedido.substring(0, 10) }}
              </p>
              <p>
                <span class="font-semibold">Estado:</span> {{ item.estado || "Pagado" }}
              </p>

              <p>
                <span class="font-semibold">Total:</span>
                <span class="text-green-600 font-bold">${{ item.total }}</span>
              </p>


              
            </div>
            <div class="text-right">
              <v-btn
                color="orange"
                class="text-white hover:bg-gray-200"
                small
                @click="showProducto(item)"
              >
                <v-icon left size="18">mdi-eye</v-icon>
                Ver Detalles
              </v-btn>
            </div>
          </div>
        </div>

        <!-- Modal de detalles -->
        <v-dialog v-model="dialogDetalle" max-width="none" width="100%">
          <v-card
            class="bg-white rounded-xl shadow-xl p-4 sm:p-6 w-full max-w-[500px] mx-auto"
          >
            <v-card-title
              class="text-xl sm:text-2xl font-bold text-gray-900 mb-4 flex justify-between items-center"
            >
              Detalles del Pedido
              <v-btn
                icon="mdi-close"
                variant="text"
                @click="dialogDetalle = false"
              ></v-btn>
            </v-card-title>

            <v-card-text
              v-if="detallePedido"
              class="text-xs sm:text-sm text-gray-700 space-y-4"
            >
              <div class="space-y-2 text-gray-800 text-sm">
                <p class="flex items-center"></p>
                <p class="flex items-center">
                  <v-icon class="mr-2 text-blue-600" size="18">mdi-receipt</v-icon>
                  <span class="font-semibold mr-1">Referencia:</span>
                  {{ detallePedido.referencia_frog }}
                </p>

                <p class="flex items-center">
                  <v-icon class="mr-2 text-green-600" size="18"
                    >mdi-calendar-clock</v-icon
                  >
                  <span class="font-semibold mr-1">Fecha:</span>
                  {{ detallePedido.fecha_pedido.substring(0, 10) }}
                </p>
              <p class="flex items-center">
                  <v-icon class="mr-2 text-green-600" size="18"
                    >mdi-calendar-clock</v-icon
                  >
                  <span class="font-semibold mr-5"> Tienda:</span>
                  {{ detallePedido.CTECLI_DENCOMERCIA }}
                </p>
                <p class="text-caption text-grey-darken-1">
                  {{ `${detallePedido.CTEDIR_CALLE || ''} 
                    ${detallePedido.CTEDIR_CALLEENTRE1 ? ' entre ' + detallePedido.CTEDIR_CALLEENTRE1 : ''} 
                    ${detallePedido.CTEDIR_CALLEENTRE2 ? ' y ' + detallePedido.CTEDIR_CALLEENTRE2 : ''}, 
                    ${detallePedido.CTEDIR_COLONIA || ''}, 
                    CP ${detallePedido.CTEDIR_CP || ''}`.replace(/\s+/g, ' ').trim() }}
                </p>


                <p class="flex items-center">
                  <v-icon class="mr-2 text-yellow-500" size="18">mdi-information</v-icon>
                  <span class="font-semibold mr-1">Estado:</span>
                  {{
                    detallePedido.estado === 10
                      ? "Pagado"
                      : detallePedido.estado || "Pagado"
                  }}
                </p>

                <p class="flex items-center">
                  <v-icon class="mr-2 text-red-600" size="18">mdi-cash</v-icon>
                  <span class="font-semibold mr-1">Total:</span> ${{
                    Number(detallePedido.total).toLocaleString("es-MX", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })
                  }}
                </p>

                <!-- Modal de detalles
                                                <p class="flex items-center">
                              <v-icon class="mr-2 text-green-600" size="18">mdi-cash</v-icon>
                              <span class="font-semibold mr-1">Usted ahorro:</span> ${{ Number(finalAhorro ||
                                0).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                            </p>   -->
              </div>

              <div class="overflow-x-auto">
                <table
                  class="min-w-full divide-y divide-gray-200 border border-gray-200 rounded-lg text-xs sm:text-sm font-sans"
                >
                  <thead class="bg-gray-100 text-gray-700">
                    <tr>
                      <th class="px-2 sm:px-4 py-2 text-left">Imagen</th>
                      <th class="px-2 sm:px-4 py-2 text-left">Producto</th>
                      <th class="px-2 sm:px-4 py-2 text-center">Cantidad</th>
                      <th class="px-2 sm:px-4 py-2 text-right">Subtotal</th>
                    </tr>
                  </thead>

                  <tbody class="bg-white divide-y divide-gray-100">
                    <!-- Filas de productos -->
                    <tr v-for="(detalle, index) in detallePedido.detalles" :key="index">
                      <td class="px-2 sm:px-4 py-2 text-center">
                        <v-img
                          :src="detalle.foto"
                          max-height="40"
                          max-width="40"
                          class="mx-auto rounded"
                          contain
                        />
                      </td>
                      <td class="px-2 sm:px-4 py-2">{{ detalle.nombre }}</td>
                      <td class="px-2 sm:px-4 py-2 text-center">
                        {{ detalle.cantidad }}
                      </td>
                      <td class="px-2 sm:px-4 py-2 text-right">
                        ${{ detalle.subtotal }}
                      </td>
                     
                    </tr>

                    <!-- Fila total -->
                    <tr class="font-bold bg-gray-100">
                      <td colspan="2" class="px-2 sm:px-4 py-2 text-right">
                        Total Cantidad:
                      </td>
                      <td class="px-2 sm:px-4 py-2 text-center">
                        {{
                          detallePedido.detalles.reduce(
                            (acc, item) => acc + Number(item.cantidad),
                            0
                          )
                        }}
                      </td>
                      <td class="px-2 sm:px-4 py-2 text-right">
                        ${{
                          detallePedido.detalles.reduce(
                            (acc, item) => acc + Number(item.subtotal),
                            0
                          )
                        }}
                      </td>

                   
                    </tr>

                    <!-- Fila final para MV Coins ganados -->
                    <tr class="bg-orange font-bold text-white">
                      <td colspan="3" class="px-2 sm:px-4 py-2 text-right">
                        Total MV Coins Ganados:
                      </td>
                      <td class="px-2 sm:px-4 py-2 text-right font-bold text-white">
                        ${{
                          Number(
                            detallePedido.detalles[0]?.mv_coins_ganados || 0
                          ).toLocaleString("es-MX", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })
                        }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </v-card-text>

            <v-card-actions class="justify-end mt-4">
              <v-btn
                @click="dialogDetalle = false"
                class="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg"
              >
                Cerrar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        
      </v-container>
    </v-main>
  </div>

   <bottom-navigation class="fixed-bottom-nav"/>

    </v-app>

</template>

<script>
import axios from "axios";
import appbarView from "./appbar/appbarView.vue";
import BottomNavigation from "./submenu/BottomNavigation.vue";

export default {
  components: { appbarView, BottomNavigation },
  data() {
    return {
      drawer: false,

      search: "",
      pedidos: [],
      user: {},
      headers: [
        { key: "referencia_frog", title: "Pedido ID" },
        { key: "fecha_pedido", title: "Fecha de Pedido" },
        { key: "estado", title: "Estado" },
        { key: "total", title: "Total" },


        { key: "acciones", title: "Acciones" },
        { key: "udn", title: "UDN" }, // 👈 corregido
      ],
      page: 1,
      detallePedido: null,
      dialogDetalle: false,
    };
  },
  methods: {
    obtenerDatos() {
      const user = JSON.parse(localStorage.getItem("user"));
      if (user) this.user = user;
    },
    async obtenerConsultaPedidos() {
      try {
        if (!this.user || !this.user.cliente) return;
        const url = ` https://mvexpress.mx/api/cliente/pedido/${this.user.cliente}`;

        const response = await axios.get(url);
        this.pedidos = Array.isArray(response.data) ? response.data : [response.data];
        console.log("Pedidos obtenidos:", this.pedidos);
      } catch (error) {
        console.error("Error al obtener los pedidos:", error);
      }
    },

    async showProducto(pedido) {
      try {
        if (!pedido.detalles) {
          const detalleUrl = `https://mvexpress.mx/api/find/pedido/${pedido.pedido_id}`;

          const detalleResponse = await axios.get(detalleUrl);
          pedido.detalles = detalleResponse.data;
        }
        this.detallePedido = pedido;
        this.dialogDetalle = true;
      } catch (error) {
        console.error(`Error al obtener detalles del pedido ${pedido.pedido_id}:`, error);
      }
    },
  },
  mounted() {
    this.obtenerDatos();
    this.obtenerConsultaPedidos();
  },

  computed: {
    finalAhorro() {
      if (
        !this.detallePedido ||
        !Array.isArray(this.detallePedido.detalles) ||
        this.detallePedido.detalles.length === 0
      ) {
        return 0;
      }

      const nuevoAhorro = Number(this.detallePedido.detalles[0].ahorro) || 0;
      const total = Number(this.detallePedido.total) || 0;

      console.log("Nuevo ahorro:", nuevoAhorro);
      console.log("Total pedido:", total);

      const finalAhorro = nuevoAhorro - total;
      return finalAhorro;
    },
  },
};
</script>

<style scoped>
body {
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f5f5f5;
  /* Opcional para darle un fondo claro */
}

.v-main {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}

.v-data-table {
  width: 100%;
  overflow-x: auto;
  /* Agregado para evitar desbordamientos en pantallas pequeñas */
}

.v-dialog .v-card {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.v-btn {
  text-transform: none;
  padding: 6px 12px;
}

.drawer-arrow {
  position: fixed;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  z-index: 999;
  background-color: white;
  border-radius: 0 50% 50% 0;
  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.1);
}
.fixed-bottom-nav {
  position: fixed;
  left: 0;
  right: 0;
  bottom: env(safe-area-inset-bottom); /* respeta la zona segura del teléfono */
  z-index: 9999;
}

.bounce-arrow {
  animation: bounce 1s infinite;
}

@keyframes bounce {
  0%,
  100% {
    transform: translateX(0);
  }
  50% {
    transform: translateX(5px);
  }
}
</style>
